import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'

function getGoogleDriveDownloadLink(files, token) {
	const filesDataArray = files.map(file => http_agent.get('https://www.googleapis.com/drive/v2/files/' + file.id)
		.set('Authorization', 'Bearer ' + token)
		.send({})
		.withCredentials()
		.use(superagentPromisePlugin))
	return new Promise(function(resolve) {
		Promise.all(filesDataArray).then(data => {
			resolve(data)
		})
	})
}

export default {
	getGoogleDriveDownloadLink,
}
